export { default as UpDownIcon } from './updown.svg';
export { default as RightIcon } from './right.svg';
export { default as EarthIcon } from './earth.svg';

// Navigators Icons (filters)
export { default as FilterTicketsIcon } from './tickets.svg';
export { default as FilterOnlineIcon } from './online.svg';
export { default as FilterExpIcon } from './experiences.svg';
export { default as FilterFoodIcon } from './food.svg';
export { default as FilterAttractionIcon } from './attractions.svg';
export { default as FilterSportIcon } from './sport.svg';
export { default as LocationIcon } from './location.svg';
export { default as MarkerIcon } from './marker.svg';
export { default as SearchIcon } from './search.svg';
export { default as FilterControlsIcon } from './filter-controls-icon.svg';
export { default as ArrowIcon } from './arrow.svg';
export { default as MapIcon } from './map.svg';
export { default as PlusCircleIcon } from './plus-circle-icon.svg';
export { default as CloseCircleIcon } from './close-circle-icon.svg';
export { default as ButtonArrowIcon } from './button-arrow-icon.svg';
export { default as ArrowRightIcon } from './arrow-right-icon.svg';

// export { default as MobileVoucher } from './mobile-vouchers.svg';
// export { default as DesktopVoucher } from './desktop-vouchers.svg';
